var _Defs, _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Defs, Path } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: style */
function SvgWarning(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    fill: "none",
    fillOpacity: 0,
    viewBox: "0 0 24 24"
  }, props), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null)), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12 16.99V17m0-10v7m9-2a9 9 0 11-18 0 9 9 0 0118 0z"
  })));
}
export default SvgWarning;